var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"floating-button",attrs:{"id":"fab-button"},on:{"click":_vm.triggerOnclick}},[_c('font-awesome-icon',{staticClass:"floating-button-icon",attrs:{"icon":"plus"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }